import { isFunction } from "@tradingApp/utils/isFunction";

type ContextSetupFn = (context: CanvasRenderingContext2D) => void;

export function measureText(
  text: string | number | unknown,
  contextSetupFn?: ContextSetupFn,
): TextMetrics {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (context === null) {
    throw new Error("CanvasRenderingContext2D is null");
  }

  if (isFunction(contextSetupFn)) {
    contextSetupFn(context);
  }

  const measure = context.measureText(String(text || ""));
  canvas.remove();

  return measure;
}
